import React, { useMemo } from 'react';
import { markdownToPlain } from '../../utils/answerClipboard';
import QuizCopyButton from './QuizCopyButton';
import './InchatQuiz.css';

/**
 * 퀴즈·카드를 풀이 화면 대신 글로 보여 준다 — 답변을 받는 중(정답 없이 문제만), 기능이 꺼졌을 때, 형식이 틀렸을 때.
 * 펜스 안 JSON 은 어떤 경우에도 그대로 보이지 않는다.
 */
const QuizPlainView = ({ markdown, copyMarkdown = '', pending = false, kind = 'quiz' }) => {
  const plain = useMemo(() => (markdown ? markdownToPlain(markdown) : ''), [markdown]);
  const noun = kind === 'flashcards' ? '카드' : '퀴즈';

  if (!plain) {
    return (
      <div className={`wq-quiz wq-quiz--plain ${pending ? 'is-pending' : ''}`} role="status">
        <p className="wq-quiz__notice">
          {pending ? `${noun}를 만들고 있어요…` : `${noun}를 불러오지 못했어요. 「다시 만들기」로 다시 받아 보세요.`}
        </p>
      </div>
    );
  }

  const [title, ...rest] = plain.split('\n');
  return (
    <section aria-busy={pending || undefined} aria-label={title} className={`wq-quiz wq-quiz--plain ${pending ? 'is-pending' : ''}`}>
      <div className="wq-quiz__head">
        <div className="wq-quiz__meta">
          <span className="wq-quiz__title">{title}</span>
          {pending && <span className="wq-quiz__count">{noun}를 만들고 있어요</span>}
        </div>
        {copyMarkdown && <QuizCopyButton kind={kind} label={title} markdown={copyMarkdown} />}
      </div>
      <div className="wq-quiz__plain">{rest.join('\n').trim()}</div>
    </section>
  );
};

export default QuizPlainView;
